<template>
    <div class="app-license-keyboard">
        <span @click="show()">
            <slot>
                <i class="el-icon-s-grid icon" />
                <font>键盘</font>
            </slot>
        </span>
        <div v-if="isShow" class="license-container">
            <van-popup v-model="isShow" position="bottom">
            <div class="license-bar">
                <span class="res-view">预览: {{ licenseNumber }}</span>
                <div>
                    <span class="confirm" @click="confirm()">完成</span>
                    <span class="close" @click="close()">关闭</span>
                </div>
            </div>
            <template v-if="type">
                <template v-for="(items,k) in licenseNumberModels">
                    <div :key="k" class="license-buttons">
<!--                        <span v-if="k== 3" :disabled="!licenseNumber" class="model" :class="{'disabled-btn':!licenseNumber}" @click="toggle()">-->
<!--                            ABC-->
<!--                        </span>-->
                        <template v-for="(item,j) in items">
                            <span :key="j" @click="handleChinese(item)">{{ item }}</span>
                        </template>
                        <span v-if="k== 3" class="delete" :disabled="!licenseNumber" :class="{'disabled-btn':!licenseNumber}">删除</span>
                    </div>
                </template>
            </template>
            <template v-else>
                <template v-for="(items,k) in abcAndNums">
                    <div :key="k" class="license-buttons">
<!--                        <span v-if="k== 3" :disabled="!licenseNumber" class="model" :class="{'disabled-btn':!licenseNumber}" @click="toggle()">-->
<!--                            字-->
<!--                        </span>-->
                        <template v-for="(item,j) in items">
                            <span :key="j" @click="handleAbcNum(item)">{{ item }}</span>
                        </template>
                        <span v-if="k== 3" class="delete" :disabled="!licenseNumber" :class="{'disabled-btn':!licenseNumber}" @click="deleteLicense()">删除</span>
                    </div>
                </template>
            </template>
            </van-popup>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue'
    import {
        Popup,
    } from 'vant'

    Vue.use(Popup);

    export default {
        name:'keyboard',
        model: {
            value: 'license',
            event: 'confirm'
        },
        props: {
            license: {
                required: false,
                type: [String],
                default: null
            }
        },
        data() {
            return {
                isShow: false,
                licenseNumberModels: [
                    [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
                    [`Q`, `W`, `E`, `R`, `T`, `Y`, `U`, `I`, `O`],
                    [`P`, `A`, `S`, `D`, `F`, `G`, `H`, `J`, `K`, `L`],
                    [`Z`, `X`, `C`, `V`, `B`, `N`, `M`]
                ],
                abcAndNums: [
                    [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
                    [`Q`, `W`, `E`, `R`, `T`, `Y`, `U`, `I`, `O`],
                    [`P`, `A`, `S`, `D`, `F`, `G`, `H`, `J`, `K`, `L`],
                    [`Z`, `X`, `C`, `V`, `B`, `N`, `M`]
                ],
                type: true,
                licenseNumber: null //车牌输入的值
            };
        },
        watch: {
            licenseNumber(val) {
                //删除完的时候返回到初始界面
                if (!val) {
                    this.type = true;
                }
            }
        },
        methods: {

            /**
             * 弹出键盘
             */
            show() {
                this.isShow = true;
                this.licenseNumber = null;
                this.type = true;
            },

            /**
             * 切换
             */
            // toggle() {
            //     if (this.licenseNumber) {
            //         this.type = !this.type;
            //     }
            // },

            /**
             * 汉字输入
             */
            handleChinese(key) {
                this.licenseNumber = key;
                //输入1个汉字切换到英文输入
                this.type = false;
            },

            /**
             * 数字和字母输入
             */
            handleAbcNum(key) {
                if (this.licenseNumber.length < 17) { //最多允许输入8位
                    this.licenseNumber += key;
                }
            },

            /**
             * 删除车牌
             */
            deleteLicense() {
                if (this.licenseNumber) {
                    this.licenseNumber = this.licenseNumber.substring(0, this.licenseNumber.length - 1);
                }
            },

            /**
             * 完成
             */
            confirm() {
                if (this.licenseNumber) {
                    this.$emit('confirm', this.licenseNumber);
                }
                this.isShow = false;
            },

            /**
             * 关闭
             */
            close() {
                this.isShow = false;
            }
        }
    };
</script>
<style lang="less" scoped>
    .app-license-keyboard{

        .icon{
            font-size: 18px;
            cursor: pointer;
        }
        font{
            cursor: pointer;
        }
        .license-container{

            box-sizing: border-box;
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 175px;
            z-index: 99999999;
            background: rgba(192, 192, 192, 0.81);
            box-shadow: 0px -4px 10px 0px #8c8c8c;
            .license-bar{
                display: flex;
                justify-content: space-between;
                padding: 3px 5px;
                /*padding: 20px 40px;*/
                /*color: #f00;*/
                /*font-weight: bold;*/
                background-color: #fcfcfc;
                font-size: 14px;
                span{
                    border: 2px solid #fcfcfc;
                    background-color: #fcfcfc;
                    align-self: center;
                }
                .confirm,
                .close{
                    cursor: pointer;
                }
                .close{
                    margin-left: 20px;
                }
            }
            .license-buttons{
                padding: 1px 5px;
                margin: 0 auto;
                display: flex;
                flex-wrap:wrap;
                font-size: 16px;
                justify-content: center;
                span{
                    margin: 1px;
                    /*margin: 10px;*/
                    /*padding: 10px 15px;*/
                    flex: 1;
                    align-self: center;
                    text-align: center;
                    white-space:nowrap;
                    /*color: #3d51aa;*/
                    border: 2px solid #fcfcfc;
                    background-color: #fcfcfc;
                    border-radius: 5px;
                    cursor: pointer;
                    transition: color,background .2s ease-in;
                    &:hover{
                        background: #8c8c8c;
                        color: #fff;
                    }
                }
                .model,
                .delete{
                    background-color: #9c9c9c;
                    border: 2px solid #9c9c9c;
                    padding: 2px;
                    flex: 1;
                    color: #e5e5e5;
                }
                .disabled-btn{
                    /*color: #ccc;*/
                }
            }
        }
    }
</style>
